import React, { Component } from 'react';
const firebase = window.firebase;

class Login extends Component {

	loginGoogle() {
		var provider = new firebase.auth.GoogleAuthProvider();
		firebase.auth().signInWithPopup(provider).then(function(result) {
			var token = result.credential.accessToken;
			var user = result.user;
		}).catch(function(error) {
			var errorCode = error.code;
			var errorMessage = error.message;
			var email = error.email;
			var credential = error.credential;
		});
	}
	render() {
		return (
			<div>
				<button onClick={this.loginGoogle}>
					Login with google
				</button>

				
			</div>
		);
	}
}

/*

<button onClick={() => {
					auth.signout(() => history.push('/'))
				}}>Sign out</button>
*/

export default Login;


// WEBPACK FOOTER //
// ./src/Login.js